import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const comparisonNumberUiNodeSpec: NodeSpec<NodeCfg<'comparisonNumber'>> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'output', 'input1', 'input2' ],
    }),
    cfg: () => ({ controlValues: { not: false, operation: '=' }, id: getUID(), kind: 'comparisonNumber', disabled: false, width: 220 }),
    controls: nodeCfg => ({
        not: defineControlOpts({ cfg: { kind: 'boolean', label: 'Not' }, on: { 'update:value': defaultControlUpdateValueHandler }, value: nodeCfg.controlValues.not }),
        operation: defineControlOpts({
            cfg: {
                items: [
                    { label: '=', value: '=' },
                    { label: '>', value: '>' },
                    { label: '>=', value: '>=' },
                    { label: '<', value: '<' },
                    { label: '<=', value: '<=' },
                ],
                kind: 'selection',
                label: 'Operation',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.operation,
        }),
    }),
    inputs: nodeCfg => ({
        input1: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'number' },
                value: nodeCfg.socketDefaults?.inputs?.input1,
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
            socket: 'number',
            label: 'Input 1',
        },
        input2: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'number' },
                value: nodeCfg.socketDefaults?.inputs?.input2,
                on: { 'update:value': defaultControlUpdateValueHandler },
            }),
            socket: 'number',
            label: 'Input 2',
        },
    }),
    kindLabel: 'Number Comparison',
    nodeCategory: 'number',
    outputs: () => ({ output: { socket: 'boolean', label: 'Output' } }),
    validator: () => true,
};
